import CardCommon from '@/pages/opinion/components/CardCommon';
import { getFeedsComments } from '@/pages/opinion/services';
import React, { useEffect, useState } from 'react';
import { ChannelType, StatsDetailType, keywordStatsDetailType } from '../..';
import { arrayHasElement } from '@/pages/opinion/utils';
import SocialTable from '../../../components/SocialMedia/SocialTable';
import { usePageInfo } from '@/pages/opinion/hooks/common';
import GameStoreTable from '../../../components/SocialMedia/GameStoreTable';
export default function StatsDetailTables({
  setSortBy,
  sortBy,
  gameInfo,
  userInfo,
  channelType,
  filter,
  statsDetailType,
  selectKeyword,
  statsDetailChartsData,
  backCommentTotal = (value: number) => {},
  backLoading = (value: boolean) => {},
  renderKeyword,
}: {
  setSortBy: any;
  sortBy: any;
  gameInfo: any;
  userInfo: any;
  channelType: ChannelType;
  filter: any;
  statsDetailType: StatsDetailType;
  selectKeyword: any;
  statsDetailChartsData: any;
  backCommentTotal?: (value: number) => void;
  backLoading?: (value: boolean) => void;
  renderKeyword: any;
}) {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<any>([]);
  const [total, setTotal] = useState(0);
  const [languages, setLanguages] = useState(['origin']);
  const { pageInfo, changePageInfo } = usePageInfo({
    defaultPageInfo: { page: 1, page_size: 10 },
  });

  const setLoadingFunc = (value: boolean) => {
    setLoading(value);
    backLoading?.(value);
  };

  const fetchComments = async (params: any) => {
    setLoadingFunc(true);
    try {
      const comments = await getFeedsComments({ ...params });

      setList(comments?.list || []);
      setTotal(comments?.total || 0);
      backCommentTotal(comments?.total || 0);
    } catch (error) {
      console.log('error', error);
    }
    setLoadingFunc(false);
  };

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;

    // keyword 类型如果没有 keyword，不请求数据
    if (
      keywordStatsDetailType.includes(statsDetailType) &&
      !arrayHasElement(selectKeyword)
    ) {
      return;
    }

    const params = {
      ...gameInfo,
      ...filter,
      user_id: userInfo.userid,
      translated_to: 'origin',
      review_type: 'all',
      statistics_field: statsDetailChartsData?.dataType || 'keyword',
      channel_type: channelType,
      sort_item: sortBy.by,
      sort_model: sortBy.order,
      keyword: selectKeyword,
      need_topic_translation: true,
    };

    if (statsDetailChartsData?.dataType === 'region') {
      params.region_type = statsDetailChartsData?.regionType;
    }

    fetchComments({
      ...params,
      ...pageInfo,
    });
  }, [userInfo, gameInfo, pageInfo, sortBy, selectKeyword, filter, statsDetailType]);

  useEffect(() => {
    changePageInfo();
    setList([]);
  }, [userInfo, gameInfo, sortBy, selectKeyword, filter]);

  return (
    <CardCommon contentCard>
      <>
        {channelType === 'social' && (
          <SocialTable
            gameInfo={gameInfo}
            renderKeyword={renderKeyword}
            sortBy={sortBy}
            setSortBy={setSortBy}
            pageInfo={pageInfo}
            total={total}
            loading={loading}
            records={list}
            setPageInfo={(pageInfo: any) => {
              setList([]);
              changePageInfo(pageInfo);
            }}
            languages={languages}
            setLanguages={setLanguages}
          />
        )}
        {channelType === 'comments' && (
          <GameStoreTable
            gameInfo={gameInfo}
            sortBy={sortBy}
            setSortBy={setSortBy}
            renderKeyword={renderKeyword}
            loading={loading}
            pageInfo={pageInfo}
            total={total}
            records={list}
            setPageInfo={(pageInfo: any) => {
              setList([]);
              changePageInfo(pageInfo);
            }}
            languages={languages}
            setLanguages={setLanguages}
          />
        )}
      </>
    </CardCommon>
  );
}
